/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import moment from 'moment';
import { getI18n } from 'react-i18next';
import RoutesDefinition from './RoutesDefinition';
import AuthIDPAPI from '../service/auth/AuthIDPAPI';

export function App() {
  const I18n = getI18n();

  useEffect(() => {
    const { origin, pathname, search } = globalThis.location;

    if (pathname === '/callback') {
      globalThis.location.replace(`${origin}/#/callback${search}`);
    }
  }, []);

  useEffect(() => {
    import('../shared/i18n/moment/initMomentLocales').then(() => {
      moment.locale(I18n.language);
    });
  }, []);

  AuthIDPAPI.endpoints.getIDPConfig.useQuery();

  return <RoutesDefinition />;
}

export default App;
